import { SMS_FIELD_NAMES, SmsOptOutValues } from '../constants';

const { IS_SMS_DISCLAIMER_ON_ALL_MESSAGES, DISABLE_SMS_DISCLAIMER } = SMS_FIELD_NAMES;

export const hydrateSmsOptOutInstructions = (
  isSMSDisclaimerOnAllMessages: boolean,
  disableSmsDisclaimer: boolean,
) => {
  if (disableSmsDisclaimer) {
    return SmsOptOutValues.Never;
  } else if (isSMSDisclaimerOnAllMessages) {
    return SmsOptOutValues.Every;
  } else {
    return SmsOptOutValues.First;
  }
};

export const deconstructSmsOptOutInstructions = (smsOptOutInstructions?: SmsOptOutValues) => {
  if (smsOptOutInstructions === SmsOptOutValues.Never) {
    return {
      [IS_SMS_DISCLAIMER_ON_ALL_MESSAGES]: false,
      [DISABLE_SMS_DISCLAIMER]: true,
    };
  } else if (smsOptOutInstructions === SmsOptOutValues.Every) {
    return {
      [IS_SMS_DISCLAIMER_ON_ALL_MESSAGES]: true,
      [DISABLE_SMS_DISCLAIMER]: false,
    };
  } else {
    // smsOptOutInstructions === SmsOptOutValues.First case
    return {
      [IS_SMS_DISCLAIMER_ON_ALL_MESSAGES]: false,
      [DISABLE_SMS_DISCLAIMER]: false,
    };
  }
};
